// import copy from 'copy-to-clipboard';
import { Modal } from 'antd';
import PluginLinks from "./PluginLinks";

export default class PluginShortcuts {

    pasteCount = 1;

    constructor(designer, {
    } = {}) {

        this.designer = designer;
    }

    install() {

        if (this.designer.mode === "view")
            return;

        const dom = this.designer.domEdit;
        dom.addEventListener("keydown", this.onkeydownHandler = this.onkeydown.bind(this));
        dom.addEventListener("keyup", this.onkeypressHandler = this.onkeypress.bind(this));
        dom.addEventListener("copy", this.oncopyHandler = this.oncopy.bind(this));
        dom.addEventListener("paste", this.onpasteHandler = this.onpaste.bind(this));
        this.designer.dom.addEventListener("mouseup", this.onMouseUpHandler = this.onMouseUp.bind(this));
    }

    uninstall() {
        if (this.designer.mode === "view")
            return;

        const dom = this.designer.domEdit;
        dom.removeEventListener("keydown", this.onkeydownHandler);
        dom.removeEventListener("keyup", this.onkeypressHandler);
        dom.removeEventListener("copy", this.oncopyHandler);
        dom.removeEventListener("paste", this.onpasteHandler);
        this.designer.dom.removeEventListener("mouseup", this.onMouseUpHandler);
    }

    onMouseUp(e) {

        if (e.button !== 0)
            return;

        this.isDragging = false;
        this.backupMouseStart = this.designer.absoluteScreenPointToView(e);
        this.pasteCount = 0;
    }


    onkeydown(e) {
        if (e.key === "Alt" && e.ctrlKey && !(this.designer.action instanceof PluginLinks))
            this.designer.action = new PluginLinks(this.designer);
        else if (e.key === "Control" && e.altKey && !(this.designer.action instanceof PluginLinks))
            this.designer.action = new PluginLinks(this.designer);
    }

    onkeypress(e) {
        if (e.key === "Alt" && e.ctrlKey && this.designer.action instanceof PluginLinks)
            this.designer.action = null;
        else if (e.key === "Control" && e.altKey && this.designer.action instanceof PluginLinks)
            this.designer.action = null;
        else if (e.key === "Delete")
            this.designer.deleteModels(this.designer.selectedItems);
        else if (e.key === "Escape")
            this.designer.selectedItems = null;
        else if (e.key === "a" && e.ctrlKey)
            this.designer.selectedItems = this.designer.diagrams;
        else if (e.key === "ArrowUp" && e.shiftKey)
            this.moveExtent(0, -1);
        else if (e.key === "ArrowDown" && e.shiftKey)
            this.moveExtent(0, 1);
        else if (e.key === "ArrowLeft" && e.shiftKey)
            this.moveExtent(-1, 0);
        else if (e.key === "ArrowRight" && e.shiftKey)
            this.moveExtent(1, 0);
        else if (e.key === "ArrowUp" && this.designer.selectedItems.length > 0 && this.designer.selectedItems.findIndex(c => c !== this.designer.paper) >= 0)
            this.moveSelection(0, -1);
        else if (e.key === "ArrowDown" && this.designer.selectedItems.length > 0 && this.designer.selectedItems.findIndex(c => c !== this.designer.paper) >= 0)
            this.moveSelection(0, 1);
        else if (e.key === "ArrowLeft" && this.designer.selectedItems.length > 0 && this.designer.selectedItems.findIndex(c => c !== this.designer.paper) >= 0)
            this.moveSelection(-1, 0);
        else if (e.key === "ArrowRight" && this.designer.selectedItems.length > 0 && this.designer.selectedItems.findIndex(c => c !== this.designer.paper) >= 0)
            this.moveSelection(1, 0);
        else if (e.key === "ArrowUp")
            this.moveExtent(0, -1);
        else if (e.key === "ArrowDown")
            this.moveExtent(0, 1);
        else if (e.key === "ArrowLeft")
            this.moveExtent(-1, 0);
        else if (e.key === "ArrowRight")
            this.moveExtent(1, 0);
        else if (e.code === "Minus" && e.shiftKey)
            this.zoomExtent(1.2);
        else if (e.code === "Equal" && e.shiftKey)
            this.zoomExtent(.8);
    }

    onpaste(e) {
        e.preventDefault();

        let txt = e.clipboardData.getData("diagrams");
        if (!txt)
            return;

        let models = this.designer.createModelsByJson(txt);
        if (!models || !models.length)
            return;

        let center = this.backupMouseStart;
        let dx = center ? models[0].x - center.x : 0;
        let dy = center ? models[0].y - center.y : 0;

        models.forEach(c => {
            c.setRandomId();

            if (center) {
                c.x = c.x - dx - c.width.getActualLength() / 2 + 50 * this.pasteCount;
                c.y = c.y - dy - c.height.getActualLength() / 2 + 50 * this.pasteCount;
            }
            else {
                c.x = c.x + 50 * this.pasteCount;
                c.y = c.y + 50 * this.pasteCount;
            }

            this.designer.addModel(c, false, false);
        })

        this.designer.selectedItems = models;
        this.pasteCount++;
    }

    oncopy(e) {
        e.preventDefault();

        if (this.designer.selectedItems.length === 0)
            return;

        let diagrams = [... this.designer.selectedItems];
        // const parent = diagrams[0]._sys.parent;
        for (let i = 0; i < diagrams.length; i++) {
            const d = diagrams[i];
            // if (d._sys.parent !== parent) {

            //     return;
            // }
            diagrams[i] = d.toJsonObject();
            const location = d.getViewLocation();
            diagrams[i].model.x = location.x;
            diagrams[i].model.y = location.y;
        }

        let txt = JSON.stringify(diagrams);
        e.clipboardData.setData("diagrams", txt);

        this.pasteCount = 1;
        this.backupMouseStart = null;
    }

    moveSelection(x, y) {

        const items = this.designer.selectedItems;
        items.forEach(c => {
            c.x += Math.round(x * 10 * this.designer.resolution);
            c.y += Math.round(y * 10 * this.designer.resolution);
        });
    }

    moveExtent(x, y) {

        let dx = -x * 50 * this.designer.resolution;
        let dy = -y * 50 * this.designer.resolution;

        let env = { ...this.designer.extent };
        env.left += dx;
        env.top += dy;
        this.designer.flyToRect(env, false);
    }

    zoomExtent(rate) {

        let w = this.designer.extent.width * rate;
        let h = this.designer.extent.height * rate;

        let x = this.designer.extent.left + (this.designer.extent.width - w) / 2;
        let y = this.designer.extent.top + (this.designer.extent.height - h) / 2;

        this.designer.flyToRect({
            left: x,
            top: y,
            width: w,
            height: h,
        }, false);

    }
}